import * as moment from 'moment'
import { ShoppingCart } from '../models/models';
import { StoreService } from '../services/store.service';
import { DataService } from '../services/data.service';
import { ToolsService } from '../services/tools.service';
export class Utility {

  static calculateAge(date: Date): number {
      return moment().diff(date, 'years')
  }

  static getDateWithtimeZoneOffset(date: Date) {
      //return date;
      let dateCopy = new Date(date.getTime());
      dateCopy.setTime(dateCopy.getTime() - (this.getTimeZoneoffset() * 60 * 1000));
      return dateCopy;
  }

  static getTimeZoneoffset() {
      var timeZoneOffset = new Date().getTimezoneOffset();
      var minutes = ((-1) * timeZoneOffset);
      return minutes;
  }

  static readAntiForgeryToken()
  {
    if(document.cookie){
    const xsrfToken = document.cookie
			.split("; ")
			.find(row => row.startsWith("XSRF-TOKEN="));
      if (!xsrfToken) {
        return "";
      }
      return xsrfToken.split("=")[1];
    }
    else{
    return "";
    }
  }

  static async clearSessionCart(storeService:StoreService,dataService:DataService,toolsService:ToolsService) {

    let orderId = localStorage.getItem("orderId");

    if (orderId) {

      let postData = {
        orderId: orderId,
        isPaymentCompletede: false,
        autoDelete: 0,
      }

      localStorage.removeItem("orderId");
      
      if(storeService != null && storeService.shoppingCart != null && storeService.shoppingCart.paymentDone == false) {

        await dataService.post<any>(`/ShoppingCart/Clear`, postData)
          .then(response => {
            toolsService.ProcessHttpResponse(response, () => {
              if (!response.succeeded) {
                toolsService.showError("Failed to empty the Cart");
              }
              storeService.shoppingCart = new ShoppingCart();
            });
          });
      }

    }
  }
}